/**
 * @generated SignedSource<<03edd7781757b3dca25654660c307831>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateBookingPaymentMethodInput = {
  bookingId: string;
  paymentCardOnFileId: string;
};
export type useUpdatePaymentMethodOnBookingMutation$variables = {
  input: UpdateBookingPaymentMethodInput;
};
export type useUpdatePaymentMethodOnBookingMutation$data = {
  readonly responsePayload: {
    readonly booking: {
      readonly id: string;
      readonly paymentCardOnFile: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdatePaymentMethodOnBookingMutation = {
  response: useUpdatePaymentMethodOnBookingMutation$data;
  variables: useUpdatePaymentMethodOnBookingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareCardOnFile",
  "kind": "LinkedField",
  "name": "paymentCardOnFile",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v10 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "ID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdatePaymentMethodOnBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateBookingPaymentMethodPayload",
        "kind": "LinkedField",
        "name": "updateBookingPaymentMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdatePaymentMethodOnBookingMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UpdateBookingPaymentMethodPayload",
        "kind": "LinkedField",
        "name": "updateBookingPaymentMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "booking",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e47271f62030784a6e9bb2d20d39ef12",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "responsePayload": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "UpdateBookingPaymentMethodPayload"
        },
        "responsePayload.booking": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Booking"
        },
        "responsePayload.booking.__typename": (v9/*: any*/),
        "responsePayload.booking.id": (v10/*: any*/),
        "responsePayload.booking.paymentCardOnFile": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "SquareCardOnFile"
        },
        "responsePayload.booking.paymentCardOnFile.id": (v10/*: any*/),
        "responsePayload.errors": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "ValidationError"
        },
        "responsePayload.errors.__typename": (v9/*: any*/),
        "responsePayload.errors.code": (v9/*: any*/),
        "responsePayload.errors.field": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "String"
        },
        "responsePayload.errors.message": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        },
        "responsePayload.success": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Boolean"
        }
      }
    },
    "name": "useUpdatePaymentMethodOnBookingMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdatePaymentMethodOnBookingMutation(\n  $input: UpdateBookingPaymentMethodInput!\n) {\n  responsePayload: updateBookingPaymentMethod(input: $input) {\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n    success\n    booking {\n      __typename\n      id\n      paymentCardOnFile {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7263038ad7a620e6dc31217db9ff4601";

export default node;
